import { IBar, IScoreEditorThis, ISelectedNote } from "../../../../../common/types";
import { deselectNote } from "./deselectNote";

export const handleChangeLyric = function (this: IScoreEditorThis, barIndex: number, noteIndex: number, activeVoice: number, _lyric: string, isSecondLyrics?: boolean) {
    this.deselectNote = deselectNote.bind(this);
    let lyric = _lyric.trim();
    const score = { ...this.state.score };
    const activeBars = score["bars" + (activeVoice || "")] as IBar[];
    let h = activeBars[barIndex].notes[noteIndex][isSecondLyrics ? "h2" : "h"];
    let hasHypen = !!h;
    let selectedNote: ISelectedNote | null = {
        bar: barIndex,
        note: noteIndex,
        lyric: true,
        lyric2: isSecondLyrics,
    };
    if (_lyric.slice(-1) === " " || lyric.slice(-1) === "-") {
        if (lyric.slice(-1) === "-") {
            lyric = lyric.slice(0, -1);
            hasHypen = true;
        }
        if (_lyric.slice(-1) === " ") {
            hasHypen = false;
        }
        selectedNote.note++;
        if (activeBars[barIndex].notes.length === selectedNote.note) {
            selectedNote.note = 0;
            selectedNote.bar++;
        }
        if (!activeBars[selectedNote.bar]?.notes[selectedNote.note]) {
            selectedNote = null;
            (document.activeElement as HTMLElement).blur();
        }
    }

    activeBars[barIndex].notes[noteIndex][isSecondLyrics ? "y2" : "y"] = lyric;
    if (hasHypen) {
        activeBars[barIndex].notes[noteIndex][isSecondLyrics ? "h2" : "h"] = 1;
    } else {
        delete activeBars[barIndex].notes[noteIndex][isSecondLyrics ? "h2" : "h"];
    }
    this.setState({ score, selectedNote, activeVoice: +activeVoice, restMode: false }, () => {
        if (!this.hasClickEventListener) {
            this.hasClickEventListener = true;
            this.scoreRef.addEventListener("click", this.deselectNote, true);
        }
    });
};
